module.exports = __webpack_public_path__ + "img/star1.62287250.png";